import { ApiModule, type PaginatedResponseData } from '@common/index';
import type { AmountItem, Amount } from '../models';

export class AmountApi extends ApiModule {
  protected endpoint = '/amount';

  public async pageAmounts(params: any) {
    return this.api.post<PaginatedResponseData<AmountItem>, any>(
      `${this.endpoint}/page?page=${params.page}&size=${params.itemsPerPage}&sort=${params.sort ?? ''}`,
      {
        ...params
      }
    );
  }

  public loadAmountDetails(id: number) {
    return this.api.get<Amount>(`${this.endpoint}?id=${id}`);
  }

  public saveAmount(params: any) {
    return this.api.post(`${this.endpoint}`, {
      ...params
    });
  }

  public deleteAmount(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }
}
